import { Box, Card, CardContent, CardHeader, Stack } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { LocationBrandingDetails } from '@occc/graphql';

const NO_COLOR_MESSAGE = 'Not set';

type ColorChipProps = {
  color?: string | null;
  label: string;
};

const ColorChip = ({ color, label }: ColorChipProps) => (
  <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, px: 2, py: 1.5 }}>
    <Stack direction='row' spacing={1} alignItems='center'>
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: 1.5,
          border: 1,
          borderColor: 'divider',
          bgcolor: color || 'transparent',
          flexShrink: 0,
        }}
      />
      <Stack spacing={0.5}>
        <Typography variant='body2' color='text.secondary'>
          {label}
        </Typography>
        <Typography variant='body1' color='text.primary'>
          {color || NO_COLOR_MESSAGE}
        </Typography>
      </Stack>
    </Stack>
  </Box>
);

type StoreBrandingCardProps = {
  brandingDetails?: Pick<LocationBrandingDetails, 'primaryColor' | 'secondaryColor'> | null;
};

export const StoreBrandingCard = ({ brandingDetails }: StoreBrandingCardProps) => (
  <Card>
    <CardHeader
      title={
        <Typography variant='h6' component='h3'>
          Store Branding
        </Typography>
      }
    />
    <CardContent>
      <Stack direction='row' spacing={2} flexWrap='wrap'>
        <ColorChip color={brandingDetails?.primaryColor} label='Primary Color' />
        <ColorChip color={brandingDetails?.secondaryColor} label='Secondary Color' />
      </Stack>
    </CardContent>
  </Card>
);
